import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const apiGet = (path, params) =>
  api.get(path, { params }).then((r) => r.data);
export const apiPost = (path, data) => api.post(path, data).then((r) => r.data);
export const apiPut = (path, data) => api.put(path, data).then((r) => r.data);
export const apiPatch = (path, data) => api.patch(path, data).then((r) => r.data);
export const apiDelete = (path) => api.delete(path).then((r) => r.data);
